import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { FetchStatus, HTTPStatusCode } from '@as-react/common-types';
import { useState, useEffect } from 'react';
import CustomerApi from '../../api/customer/CustomerApi';
import { AccountVouchers } from '../../components/account/account-vouchers/AccountVouchers';
const AccountVouchersContainer = ({ title }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const [status, setStatus] = useState(FetchStatus.PENDING);
    const [vouchers, setVouchers] = useState([]);
    const fetchVouchers = () => __awaiter(void 0, void 0, void 0, function* () {
        setStatus(FetchStatus.PENDING);
        try {
            const answer = yield CustomerApi.getVouchers(servicesEndpoint, defaultRequestParams);
            if (answer.status !== HTTPStatusCode.NoContent) {
                setVouchers(answer.data);
            }
            setStatus(FetchStatus.RESOLVED);
        }
        catch (_a) {
            setStatus(FetchStatus.REJECTED);
        }
    });
    useEffect(() => {
        fetchVouchers();
    }, []);
    return _jsx(AccountVouchers, { vouchers: vouchers, status: status, title: title });
};
export default AccountVouchersContainer;
